export default __webpack_public_path__ + "static/img/vogue_scene_animated_0746.9897412.webp";